// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"337":"perfil","644":"conta","731":"trilha","747":"ranking","796":"duelo","827":"hoje"}[chunkId] + "." + {"337":"cedd0f68","644":"be4546a4","731":"f84deaea","747":"891627e8","796":"ce69fb13","827":"18d166ec"}[chunkId] + ".js";
};